import { useContext, useMemo } from 'react';

import { expValEquals } from '@confluence/feature-experiments';

import { CommentContext } from '../context/content-type-comment-context.tsx';
import { ContentTypesCommentService } from '../services/content-types-comment-service.ts';

export const useCommentService = (): {
	commentService: ContentTypesCommentService;
} => {
	const context = useContext(CommentContext);

	const memoizedCommentService = useMemo(() => new ContentTypesCommentService(), []);

	if (!context) {
		return {
			commentService: expValEquals(
				'cc_fe_performance_page_comments_stability',
				'cohort',
				'experiment',
			)
				? memoizedCommentService
				: new ContentTypesCommentService(),
		};
	}
	return context;
};
